import {
  IButtonStyles,
  IDetailsColumnStyles,
  IDetailsListStyles,
  IRawStyle,
  ITooltipHostStyles,
} from '@fluentui/react';
import { CommonStyles, FontSizes, FontWeights, IH2OTheme, Sizes } from '@h2oai/ui-kit';
import { CSSProperties } from 'react';

export const customTableStyles = (theme: IH2OTheme, contentHeight?: string): Partial<IDetailsListStyles> => ({
  root: {
    height: '100%',
    selectors: {
      '.ms-DetailsList': {
        height: '100%',
      },
      '.ms-DetailsHeader': {
        padding: Sizes.padding,
        paddingRight: 0,
        paddingLeft: 0,
        background: theme.palette?.white,
      },
      '.ms-DetailsHeader-cell': {
        borderRight: `1px solid ${theme.palette?.gray300}`,
        color: theme.palette?.gray700,
      },
      '.ms-DetailsHeader-cell:hover': {
        background: theme.palette?.white,
      },
      '.ms-DetailsRow-cell': {
        display: 'flex',
        alignItems: 'center',
        fontSize: FontSizes.xsmall,
        color: theme.palette?.gray600,
        padding: Sizes.padding,
      },
      '.ms-DetailsRow': {
        backgroundColor: theme.palette?.gray200,
      },
      '.ms-DetailsRow:hover': {
        backgroundColor: theme.palette?.yellow100,
      },
      '.ms-DetailsList-contentWrapper': {
        overflowY: 'auto',
        maxHeight: contentHeight ? `calc(100vh - ${contentHeight}px)` : `calc(100vh - 450px`,
        width: 'fit-content',
      },
    },
  },
});

export const tagStyle = (theme: IH2OTheme): IRawStyle => ({
  height: 20,
  lineHeight: 20,
  padding: '0 4px',
  borderRadius: Sizes.borderRadius,
  fontSize: FontSizes.xxsmall,
  fontWeight: FontWeights.semiBold,
  marginRight: 4,
  backgroundColor: theme.semanticColors?.tagBackground,
  color: theme.semanticColors?.tagText,
  ...CommonStyles.truncateString,
  '&.loading': {
    overflow: 'visible',
  },
});

export const messageBarContainerStyles = {
  position: 'fixed' as const,
  top: Sizes.padding,
  right: Sizes.padding,
  zIndex: 9999999,
  width: 'auto',
};

export const groupIconStyle = (selected: boolean, theme: IH2OTheme): IButtonStyles => ({
  root: {
    marginLeft: 4,
    cursor: 'pointer',
    background: selected ? theme.palette?.gray350 : '',
  },
  rootHovered: {
    background: selected ? theme.palette?.gray350 : theme.palette?.gray300,
  },
});

export const columnStyles = (sortable: boolean): Partial<IDetailsColumnStyles> => ({
  root: { cursor: sortable ? 'pointer' : '' },
  cellName: { width: '100%' },
});

export const columnHeaderContainerStyles: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'space-between',
};

export const tooltipHostStyles: Partial<ITooltipHostStyles> = {
  root: {
    height: '100%',
    display: 'flex',
  },
};
